import React from 'react';
import PropTypes from 'prop-types';
import { CrossIconDiv, DateVal, LogoDiv, SelectedChannelDiv, TextDivTopic2, TitleSelected, TopicWrapper } from './SelectChannelPage.style';
import { CrossCompIcon, CrossIcon, FacebookIcon, FacebookLogo, FlipkartIconSmall, FlipkartLogo, InstagramIconSmall, InstagramLogo, X_LOGO } from '../../Common/SvgIcon/CommonSvgIcons';
import { ErrorMessage } from '../TopicBuilder/MainContent/QueryBuilder/TopicBuilder.styled';

const SelectedTopic = ({
    topicTitle='',
    topic,
    val,
    handleRemovePopup,
    selectValid
}) => {
    return (
        <TopicWrapper>
            <TitleSelected>{topicTitle}</TitleSelected>
            {topic && <CrossIconDiv  className="cross-icon" onClick={()=>handleRemovePopup(val)}>{CrossCompIcon}</CrossIconDiv>}
            <SelectedChannelDiv >
                <TextDivTopic2 topic={topic ? true : false}><LogoDiv channel={topic?.channel == "flipkart"}>{topic?.channel == 'facebook' ? FacebookLogo : topic?.channel == 'instagram' ? InstagramLogo : topic?.channel == 'twitter' ? X_LOGO :topic?.channel == 'flipkart' ? FlipkartIconSmall : ''}</LogoDiv><p title={topic?.title || topic?.chatter_title || ''}>{topic?.title || topic?.chatter_title || ''}</p></TextDivTopic2>
                <DateVal>Start Date: {topic?.start_date?.replace(/\//g, '-') || ''} </DateVal>
                <DateVal>End Date: {topic?.end_date?.replace(/\//g, '-') || ''}  </DateVal>
            </SelectedChannelDiv>
            {selectValid && <ErrorMessage style={{ marginTop: '5px' }}>Select a valid Topic</ErrorMessage>}
        </TopicWrapper>
    );
};

export default SelectedTopic;